// Iter 62ax — Hooks for the Elevate Influence integration (via API-key proxy).
// Poll notifications every 60s so the sidebar badge stays fresh without a WS.
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export function useElevateStatus(pollMs = 60000) {
  const [state, setState] = useState({ connected: false, count: 0, public_url: '', api_url: '' });
  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get('/elevate/status');
        if (alive) setState({
          connected: !!data.connected,
          count: data.count || 0,
          public_url: data.public_url || '',
          api_url: data.api_url || '',
        });
      } catch (_) { /* silently degrade */ }
    };
    poll();
    const iv = setInterval(poll, pollMs);
    return () => { alive = false; clearInterval(iv); };
  }, [pollMs]);
  return state;
}

export function useElevateNotifCount(pollMs = 60000) {
  const status = useElevateStatus(pollMs);
  return status.count;
}

export function useElevateTasks(from, to) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    const fetchTasks = async () => {
      try {
        const { data } = await api.get('/elevate/tasks', { params: { from, to } });
        if (alive) setTasks(data.tasks || []);
      } catch (_) { if (alive) setTasks([]); }
      finally { if (alive) setLoading(false); }
    };
    fetchTasks();
    // Iter 62ba — refresh on demand (e.g. after creating a new Elevate task).
    const onRefresh = () => fetchTasks();
    window.addEventListener('asa-elevate-refresh', onRefresh);
    return () => {
      alive = false;
      window.removeEventListener('asa-elevate-refresh', onRefresh);
    };
  }, [from, to]);
  return { tasks, loading };
}

export function useElevateCashReminders(pollMs = 300000) {
  const [reminders, setReminders] = useState([]);
  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get('/elevate/cash-reminders');
        if (alive) setReminders(data.reminders || []);
      } catch (_) {}
    };
    poll();
    const iv = setInterval(poll, pollMs);
    return () => { alive = false; clearInterval(iv); };
  }, [pollMs]);
  return reminders;
}

// Iter 62ay — Cocher/décocher une tâche Elevate depuis ASA (fallback local
// si Elevate n'a pas encore l'endpoint /complete).
export async function completeElevateTask(taskId, status = 'done') {
  const { data } = await api.post(`/elevate/tasks/${taskId}/complete`, { status });
  return data;
}

// Iter 62bn — Supprimer une tâche Elevate depuis ASA (founders only).
// Cache la tâche localement dans elevate_task_overrides + proxy vers Elevate.
export async function deleteElevateTask(taskId) {
  const { data } = await api.delete(`/elevate/tasks/${taskId}`);
  return data;
}

// Iter 62ba — Créer une tâche Elevate directement depuis ASA (founders only).
export async function createElevateTask(payload) {
  const { data } = await api.post('/elevate/tasks', payload);
  return data;
}

// Iter 62bc — Liste des élèves Elevate School (page native ASA).
export function useElevateStudents(pollMs = 60000) {
  const [state, setState] = useState({ students: [], loading: true, fallback: false, error: null });
  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get('/elevate/students');
        if (alive) setState({
          students: data.students || [],
          loading: false,
          fallback: !!data.fallback,
          error: data.error || null,
        });
      } catch (e) {
        if (alive) setState((s) => ({ ...s, loading: false, error: 'fetch_error' }));
      }
    };
    poll();
    const iv = setInterval(poll, pollMs);
    const onRefresh = () => poll();
    window.addEventListener('asa-elevate-refresh', onRefresh);
    return () => {
      alive = false;
      clearInterval(iv);
      window.removeEventListener('asa-elevate-refresh', onRefresh);
    };
  }, [pollMs]);
  return state;
}
